import Vue from 'vue';
import Vuex from 'vuex';
import CarService from '@/services/car/CarService';

Vue.use(Vuex);

const state = {
    filters: {
        situacoes: ['ENVIADO_PARA_ANALISE', 'EM_ANALISE'],
        types: [],
        page: 0,
        size: 10,
        filtro: ''
    },
    reports: {
        content: [],
        number: 0,
        meta: {
            totalEmAnalise: 0,
            totalProcessadas: 0,
            totalAguardandoAnalise: 0,
            totalElements: 0,
            size: 0,
            total: 0
        }
    },
    report: null
};

const mutations = {
    SET_REPORTS(state, reports) {
        state.reports = reports;
    },
    SET_REPORT(state, report) {
        state.report = report;
    },
    SET_FILTERS(state, filters) {
        state.filters = { ...state.filters, ...filters };
    }
};

const actions = {
    async fetchCars({ commit, state }, filters = null) {
        try {
            const response = await CarService.listarCarsEmAnalise(
                filters || state.filters
            );

            commit('SET_REPORTS', {
                content: response.data.content,
                totalElements: response.data.totalElements,
                size: response.data.size,
                number: response.data.number + 1,
                meta: {
                    totalEmAnalise: response.data.meta.totalEmAnalise,
                    totalProcessadas: response.data.meta.totalProcessadas,
                    totalAguardandoAnalise:
                        response.data.meta.totalAguardandoAnalise,
                    size: response.data.meta.size,
                    totalElements: response.data.meta.totalElements,
                    total: response.data.meta.total
                }
            });
        } catch (error) {
            throw error;
        }
    },
    async detail({ commit }, id) {
        try {
            const response = await CarService.detalharAnalise(id);
            commit('SET_REPORT', response.data);
        } catch (error) {
            throw error;
        }
    },
    async changePage({ dispatch, commit, state }, page) {
        const filters = { ...state.filters, page: page };
        await dispatch('fetchCars', filters);
    },
    async downloadReport(_, id) {
        try {
            return await CarService.downloadLaudo(id);
        } catch (error) {
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
